import React, { useEffect, useState } from 'react';
import './Event.css';

import {
    Label,
    Link
} from '@fluentui/react';

export const EventInfo = (props) => {
    const [mapDestination, setMapDestination] = useState('');
    const [mailTo, setMailTo] = useState('');
    useEffect(() => {
        let dest = props.eventInfo.Address1 + ' ' + props.eventInfo.Address2 + ' ' +
            props.eventInfo.City + ' ' + props.eventInfo.USState + ' ' + props.eventInfo.PostalCode;
        let url = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(dest);
        setMapDestination(url);

        let email = 'mailto:' + props.eventInfo.OrganizerEmail;
        setMailTo(email);
    }, [props])

    return (
        <div>
        {
            props.eventInfo === '' ?
            <div></div> :
                <div>
                <br /><br />
                <Label className="subtitle">When</Label>
                <Label className="labelInfo">{props.eventDateTime[0]}</Label>
                <Label className="labelInfo">{props.eventDateTime[1]}</Label>
                <br />

                <Label className="subtitle">Where</Label>
                <Label className="labelInfo">{props.eventInfo.Location}</Label>
                <Label className="labelInfo">{props.eventInfo.Address1} {props.eventInfo.Address2}</Label>
                {
                    (props.eventInfo.City.length > 0 && (props.eventInfo.USState.length > 0 || props.eventInfo.PostalCode.length > 0)) ?
                    <Label className="labelInfo">{props.eventInfo.City}, {props.eventInfo.USState} {props.eventInfo.PostalCode}</Label>
                    :
                    <Label className="labelInfo">{props.eventInfo.City} {props.eventInfo.USState} {props.eventInfo.PostalCode}</Label>
                }                
                <Link className="linklInfo" target='_blank' href={mapDestination}>Map</Link>
                <br /><br />

                <Label className="subtitle">Contact</Label>
                <Label className="labelInfo">{props.eventInfo.OrganizerName}</Label>
                <Label className="labelInfo">{props.eventInfo.OrganizerOrganization}</Label>
                <Label className="labelInfo">{props.eventInfo.OrganizerPhone}</Label>
                <Link className="linklInfo" href={mailTo}><Label className="LabelLink">{props.eventInfo.OrganizerEmail}</Label></Link>
            </div>
        }            
        </div>
    );
}
